import { useRef, useState, useEffect } from "react";
import { useInView } from "framer-motion";
import { Reveal } from "./Reveal";
import { STATS, TESTIMONIALS } from "./data";
import { Quote, Star } from "lucide-react";

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const target = parseInt(value, 10);
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const dur = 1500;
    const tick = (t) => {
      const p = Math.min((t - start) / dur, 1);
      setN(Math.floor((1 - Math.pow(1 - p, 3)) * target));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, target]);

  return (
    <span ref={ref} className="tabular-nums">
      {n}
      {suffix}
    </span>
  );
};

export const StatsTestimonials = () => {
  return (
    <section id="testimonios" className="relative py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl bg-navy p-8 sm:p-12">
            <div className="absolute -bottom-16 -right-10 h-64 w-64 rounded-full bg-gold/15 blur-3xl" />
            <div className="relative grid grid-cols-2 lg:grid-cols-4 gap-8 text-center">
              {STATS.map((s) => (
                <div key={s.label}>
                  <div className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-gold tracking-tighter" style={{ fontFamily: "Outfit" }}>
                    <Counter value={s.value} suffix={s.suffix} />
                  </div>
                  <div className="mt-2 text-sm font-semibold text-white/70 uppercase tracking-wide">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>

        <Reveal className="mt-20 max-w-2xl">
          <span className="section-tag">La voz de la hinchada</span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-navy">
            Lo que dicen nuestros socios
          </h2>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.1}>
              <figure className="h-full bg-[#eef1f7] rounded-2xl border border-gray-100 p-7 flex flex-col">
                <Quote className="h-8 w-8 text-gold" />
                <div className="mt-3 flex gap-0.5">
                  {[...Array(5)].map((_, k) => (
                    <Star key={k} className="h-4 w-4 fill-gold text-gold" />
                  ))}
                </div>
                <blockquote className="mt-4 text-gray-700 leading-relaxed flex-1">"{t.text}"</blockquote>
                <figcaption className="mt-6 flex items-center gap-3">
                  <div className="h-11 w-11 rounded-full bg-navy text-gold flex items-center justify-center font-bold" style={{ fontFamily: "Outfit" }}>
                    {t.name[0]}
                  </div>
                  <div>
                    <div className="font-semibold text-navy text-sm">{t.name}</div>
                    <div className="text-xs text-gray-500">{t.role}</div>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
